(function () {
  "use strict";
  angular
    .module("payroll")
    .controller("paymentModalController", paymentModalController);
  paymentModalController.$inject = [
    "$uibModalInstance",
    "$scope",
    "PayrollService",
    "CommissionService",
    "AdmService",
    "InvoicesService",
    "TravelExpenseService",
    "CurrencyService",
    "payrollId",
    "getPayrolls",
    "setPayrollTag",
    "$timeout"
  ];

  function paymentModalController(
    $uibModalInstance,
    $scope,
    PayrollService,
    CommissionService,
    AdmService,
    InvoicesService,
    TravelExpenseService,
    CurrencyService,
    payrollId,
    getPayrolls,
    setPayrollTag,
    $timeout
  ) {
    let vm = this;
    vm.currenciesConvertedList = [];
    vm.payrollId = payrollId;
    vm.getPayrolls = getPayrolls;
    vm.setPayrollTag = setPayrollTag;
    vm.items = [];
    vm.history = '';
    vm.sellerSelected = '';
    vm.sellersList = "";
    vm.payrollList = [];
    vm.paymentDate = moment();
    vm.actions_disabled = false;
    vm.selectedCurrency = '';
    vm.currencies = [];
    vm.calculatedCurrency = "";
    vm.travelExpensesList = [];
    vm.commissionsList = [];
    vm.exchangeRate = 1;
    vm.statusAddItem = false;
    vm.addType = [];
    vm.atmsSalaryAdvanceList = [];
    vm.addDescription = [];
    vm.addTotal = "";
    vm.addTotalConverted = [];
    vm.inputTypeSelected = [];
    vm.totalToBePaid = 0;
    vm.get_commissions = true;
    vm.get_travel_expenses = true;
    vm.get_salary_advance = true;
    vm.addTypeList = [{
      name: "salary/bonus"
    }, {
      name: "others"
    }];
    vm.inputTypeList = [{
      name: "credit"
    }, {
      name: "debit"
    }];
    vm.bonusList = [];
    vm.othersList = [];
    vm.date = {
      startDate: null,
      endDate: null
    };
    vm.datePickerOptions = {
      singleDatePicker: true,
      format: "D-MMM-YY",
      fromLabel: "From",
      toLabel: "To"
    };
    vm.periodDatePickerOptions = {
      format: "D-MMM-YY",
      fromLabel: "From",
      toLabel: "To"
    };
    vm.bankCreditAccountList = [];
    vm.bankCreditAccountSelected = '';
    vm.loadTravelExpenses = loadTravelExpenses;
    vm.loadCommissions = loadCommissions;
    vm.getCurrencies = getCurrencies;
    vm.selectSeller = selectSeller;
    vm.loadSellers = loadSellers;
    vm.getExchangeRate = getExchangeRate;
    vm.getAtmSalaryAdvance = getAtmSalaryAdvance;
    vm.addItem = addItem;
    vm.showForm = showForm;
    vm.hideForm = hideForm;
    vm.removeItem = removeItem;
    vm.sendEmail = sendEmail;
    vm.savePayroll = savePayroll;
    vm.getInvoicesBankAccount = getInvoicesBankAccount;
    vm.close = close;
    vm.fillForm = fillForm;
    vm.exchangeRates = {};
    vm.checkTotal = checkTotal;
    vm.deleteItem = deleteItem;
    vm.getItemType = getItemType;
    vm.getItems = getItems;

    activate();

    function activate() {
      vm.loadSellers();
      vm.getCurrencies();
      vm.getInvoicesBankAccount();
    }

    function getCurrencies() {
      InvoicesService.getPaymentCurrencies().then(function (response) {
        vm.currencies = response.data;
      });
    }

    function loadSellers() {
      AdmService.getAll({'active':'1'}).then(function (response) {
        vm.sellersList = response.data;
      })
      .catch(function (err) {});
    }

    function loadTravelExpenses() {

      if (vm.get_travel_expenses) {        

        let query = [];
        query["seller_id"] = vm.sellerSelected;
        query["status"] = "open";
        query["type"] = "salary_advance";

        if ((vm.date.startDate !== null ) && (vm.date.endDate !== null)) {
            query['start'] = vm.date.startDate.format('Y-MM-DD');
            query['end'] = vm.date.endDate.format('Y-MM-DD');
        }
        query["payment_type"] = JSON.stringify(['personal_cash','personal_credit_card']);
        TravelExpenseService.getExpenseForPaymentSeller(query)
          .then(function (response) {
            vm.travelExpensesList = response.data;
            vm.travelExpensesList.forEach(function (value, key) {
              vm.getExchangeRate(value.currency).then(function(response) {

                if (value.type == 'physical_event') {
                  value.description = value.expo.expo.name + ' - ' + value.description;
                }

                if (value.type == 'virtual_event') {
                  value.description = value.virtual_expo.name + ' - ' + value.description;
                }

                if (value.type == 'other_event') {
                  value.description = value.other_event.name + ' - ' + value.description;
                }

                value.amount_converted = (parseFloat(response.data) * parseFloat(value.amount)).toFixed(2);

                if (value.type == 'salary_advance') {
                  value.payment_type = 'salary_advance';
                  value.amount_converted = parseFloat(value.amount_converted).toFixed(2) * -1;
                  value.original_amount = parseFloat(value.original_amount).toFixed(2) * -1;
                  value.amount = parseFloat(value.amount).toFixed(2) * -1;
                }

                if (value.statement) {
                  value.description = value.description + ' - ' + value.statement.description;
                }

                let obj = {};
                obj = {
                  source_id: value.id,
                  original_amount: value.amount,
                  // original_currency: 'USD',
                  original_currency: value.currency,
                  currency: vm.selectedCurrency,
                  type: value.payment_type,
                  description: value.description,
                  amount_converted: value.amount_converted,
                  url: base_url + '/#/travel_expenses/' + value.id + '/edit/',
                };
                vm.totalToBePaid = (parseFloat(vm.totalToBePaid) + parseFloat(value.amount_converted)).toFixed(2);
                if (typeof vm.items == 'undefined') {
                  vm.items = [];
                }
                vm.items.push(obj);
              });

            });
          }).then(function(){
            $timeout(function () {
              vm.checkTotal();
            }, 500);
            vm.getAtmSalaryAdvance();
          }).catch(function (err) {});

        } else {
          vm.getAtmSalaryAdvance();
        }
    }

    function getAtmSalaryAdvance() {

      if (vm.get_salary_advance) {
        
        let query = [];
        query['seller_id'] = vm.sellerSelected;
        if ((vm.date.startDate !== null ) && (vm.date.endDate !== null)) {
            query['start'] = vm.date.startDate.format('Y-MM-DD');
            query['end'] = vm.date.endDate.format('Y-MM-DD');
        }
        TravelExpenseService.getAtmSalaryAdvance(query).then(function (response) {
          vm.atmsSalaryAdvanceList = response.data;
          if (vm.atmsSalaryAdvanceList.length > 0) {
            vm.atmsSalaryAdvanceList.forEach(function (value, key) {
              vm.getExchangeRate(value.currency).then(function(response) {
                // if (value.type == "salary_advance") {
                //   value.original_amount = value.amount_usd * -1;
                // }

                value.amount_converted = parseFloat(value.amount_converted).toFixed(2) * -1;
                value.original_amount = parseFloat(value.original_amount).toFixed(2) * -1;

                value.original_amount = value.amount;
                value.amount_converted = (parseFloat(response.data) * parseFloat(value.original_amount)).toFixed(2);
                let obj = {};
                obj = {
                  source_id: value.id,
                  currency: vm.selectedCurrency,
                  original_amount: value.original_amount,
                  original_currency: value.currency,
                  type: 'atm',
                  description: 'ATM - ' + value.description,
                  amount_converted: value.amount_converted,
                  url: base_url + '/#/travel_expenses/' + value.id + '/edit/',
                };
                vm.totalToBePaid = (parseFloat(vm.totalToBePaid) + parseFloat(value.amount_converted)).toFixed(2);
                if (typeof vm.items == 'undefined') {
                  vm.items = [];
                }
                vm.items.push(obj);
              });
            });
          }
        }).then(function(){
          $timeout(function () {
            vm.checkTotal();
          }, 500);
          vm.loadCommissions();
        });

      } else {
        vm.loadCommissions();
      } 
    }

    function loadCommissions() {
      
      if (!vm.get_commissions) {
        return;
      }

      let query = [];
      query["seller_id"] = vm.sellerSelected;
      query["status"] = "authorized";
      console.log(vm.date);
      if ((vm.date.startDate !== null ) && (vm.date.endDate !== null)) {
          query['start'] = vm.date.startDate.format('Y-MM-DD');
          query['end'] = vm.date.endDate.format('Y-MM-DD');
      }
      CommissionService.getCommissionsForPaymentSeller(query)
        .then(function (response) {
          vm.commissionsList = response.data;
          vm.commissionsList.forEach(function (value, key) {
            vm.getExchangeRate(value.invoice.currency).then(function(response) {
              value.amount_converted = (parseFloat(response.data) * parseFloat(value.commission_rate)).toFixed(2);
              let obj = {};
              obj = {
                source_id: value.id,
                original_amount: value.commission_rate,
                original_currency: value.invoice.currency,
                currency: vm.selectedCurrency,
                type: 'commission',
                description: value.invoice.customer_legal_name ? value.invoice.control_id + ' - ' + value.invoice.customer_legal_name : value.invoice.control_id,
                amount_converted: value.amount_converted,
                url: value.invoice.url,
              };
              vm.totalToBePaid = (parseFloat(vm.totalToBePaid) + parseFloat(value.amount_converted)).toFixed(2);
              if (typeof vm.items == 'undefined') {
                vm.items = [];
              }
              vm.items.push(obj);
            });
          });
        })
        .then(function(){
          $timeout(function () {
            vm.checkTotal();
          }, 1000);
          vm.getItems();
          // if(payrollId) {
          //   vm.getItems();
          // }
        })
        .catch(function (err) {});
    }

    function getExchangeRate(fromCurrency) {
      let query = {};
      if (vm.selectedCurrency) {
        if(typeof vm.exchangeRates[fromCurrency] !== "undefined" && typeof vm.exchangeRates[fromCurrency][vm.selectedCurrency] !== "undefined") {
          return vm.exchangeRates[fromCurrency][vm.selectedCurrency];
        }
        query["from"] = fromCurrency;
        query["to"] = vm.selectedCurrency;
        query["date"] = moment(vm.paymentDate).format("YYYY-MM-DD");
        let result = CurrencyService.getExchangeRate(query);
        if(typeof vm.exchangeRates[fromCurrency] === "undefined") {
          vm.exchangeRates[fromCurrency] = {};
        }
        vm.exchangeRates[fromCurrency][vm.selectedCurrency] = result;
        return result;
      }
    }

    function selectSeller() {
      vm.items = [];
      vm.seller = vm.sellersList.filter(function (obj) {
        return obj.id == vm.sellerSelected;
      })[0];
      vm.tag =
        "SALARY " +
        vm.seller.name +
        " - " +
        moment(vm.paymentDate).format('MMM/YYYY').toUpperCase();
      vm.loadTravelExpenses();
    }

    function getItems () {
      if(!payrollId) {
        return false;
      }
      let query = {};
      if(payrollId) {
        query['id'] = payrollId;
      }
      PayrollService.edit(query).then(function (response) {
        let items = response.data.items;
        angular.forEach(items, function(item) {
          vm.getExchangeRate(vm.selectedCurrency).then(function(response) {

            // if(item.type == 'salary_advance' || item.type == 'atm') {
            //   item.amount_converted = parseFloat(item.amount_converted).toFixed(2) * -1;
            //   item.original_amount = parseFloat(item.original_amount).toFixed(2) * -1;
            // }

            if(item.currency !== vm.selectedCurrency || parseFloat(item.amount_converted) === 0) {
              item.amount_converted = (parseFloat(response.data) * item.original_amount).toFixed(2);
            }

            vm.totalToBePaid = (parseFloat(vm.totalToBePaid) + parseFloat(item.amount_converted)).toFixed(2);

            let obj = {};
            obj = {
              source_id: item.source_id,
              id: item.id,
              original_amount: item.original_amount,
              original_currency: item.original_currency,
              type: item.type,
              description: item.description,
              amount_converted: item.amount_converted,
              currency: item.currency
            };
            if (typeof vm.items == 'undefined') {
              vm.items = [];
            }
            angular.forEach(vm.items, function(item) {
              if(item.source_id == obj.source_id && item.type == obj.type) {
                vm.items.splice(vm.items.indexOf(item), 1);
              }
            });
            vm.items.push(obj);
          });
        });
      }).then(function(){
        $timeout(function () {
          vm.checkTotal();
        }, 500);
      });
    }

    function showForm() {
      vm.statusAddItem = true;
    }

    function hideForm() {
      vm.addDescription = "";
      vm.addType = [];
      vm.addTotal = "";
      vm.statusAddItem = false;
    }

    function getItemType (type) {
      if(type == 'personal_cash') {
        return 'Personal Cash';
      }
      if(type == 'personal_credit_card') {
        return 'Personal Creditcard';
      }
      if(type == 'salary_advance' || type == 'atm') {
        return 'Salary Advance';
      }
      if(type == 'other') {
        return 'Other';
      }
      if(type == 'salary/bonus') {
        return 'Salary/Bonus';
      }
      if(type == 'commission') {
        return 'Commission';
      }
      return type;
    }

    function removeItem (item) {
      alertify.confirm(
        'Delete Item',
        'Do you really want to delete this' + vm.getItemType(item.type) + '?',
        function () {
          if(typeof item.id !== 'undefined') {
            vm.deleteItem(item.id)
          }
          vm.items.splice(vm.items.indexOf(item), 1);
          alertify.success('Item successfull deleted!');
          vm.checkTotal();

          vm.savePayroll('waiting', false);

          $scope.$apply();
        },
        function () {
          return true;
        }
      );
    }

    function deleteItem(id) {
      PayrollService.deletePayrollItem(id).then(function(response){
          vm.checkTotal();
      });
    }

    function addItem () {
      let newItem = {};
      newItem.original_amount = vm.addTotal;
      if (vm.inputTypeSelected == "debit") {
        newItem.original_amount = vm.addTotal * -1;
      }
      newItem.description = vm.addDescription;
      newItem.type = vm.addType;
      newItem.original_currency = vm.inputCurrencySelected;
      vm.getExchangeRate(vm.inputCurrencySelected).then(function(response) {
        newItem.amount_converted = (parseFloat(response.data) * newItem.original_amount).toFixed(2);
        let obj = {
          source_id: null,
          currency: vm.selectedCurrency,
          original_amount: newItem.original_amount,
          original_currency: newItem.original_currency,
          description: newItem.description,
          amount_converted: newItem.amount_converted,
        };
        if (vm.addType == "others") {
          obj.type = 'other';
        }
        if (vm.addType == "salary/bonus") {
          obj.type = 'salary/bonus';
        }
        vm.items.push(obj);
        vm.checkTotal();
        vm.hideForm();
      });
    }

    function checkTotal () {
      vm.totalToBePaid = 0;
      angular.forEach(vm.items, function(value) {
        if((value.type == 'salary_advance' || value.type == 'atm') && value.amount_converted > 0) {
          value.amount_converted = parseFloat(value.amount_converted).toFixed(2) * -1;
          value.original_amount = parseFloat(value.original_amount).toFixed(2) * -1;
        }
        vm.totalToBePaid = parseFloat(vm.totalToBePaid) + parseFloat(value.amount_converted);
      });
    }

    function sendEmail() {
      let query = {};

      vm.seller = vm.sellersList.filter(function (obj) {
          return obj.id == vm.sellerSelected;
      })[0];

      query['items'] = [];
      query['seller_name'] = vm.seller.name;
      query['seller_email'] = vm.seller.email;
      query['tag'] = vm.tag;
      query['exchange_rate'] = vm.exchangeRate;
      query['date'] = moment(vm.paymentDate).format("YYYY-MM-DD");
      query['currency'] = vm.selectedCurrency;
      query['history'] = vm.history;
      query['items'] = JSON.stringify(vm.items);
      query['total'] = vm.totalToBePaid;

      PayrollService.sendEmailPayrrolReport(query).then(function (response) {
        alertify.success('Report sent!');
      });
    }

    function savePayroll(status, close) {
      let query = {};
      query['items'] = [];
      query['status'] = status;
      query['bank_id'] = vm.bankCreditAccountSelected;
      query['seller_id'] = vm.sellerSelected;
      query['tag'] = vm.tag;
      query['exchange_rate'] = vm.exchangeRate;
      query['date'] = moment(vm.paymentDate).format("YYYY-MM-DD");
      query['currency'] = vm.selectedCurrency;
      query['history'] = vm.history;
      query['items'] = JSON.stringify(vm.items);
      query['total'] = vm.totalToBePaid;
      if (typeof vm.payrollId !== 'undefined' && vm.payrollId !== null) {
        query['id'] = vm.payrollId;
        PayrollService.update(query).then(function (response) {
          alertify.success('Payroll edited successfully!');

          vm.setPayrollTag(vm.tag);
          vm.getPayrolls();

          if (close == true) {
            vm.close();
          }

        });
      } else {
        PayrollService.savePayroll(query).then(function (response) {
          if(!response.error) {
            alertify.success('Payroll created successfully!');
            vm.setPayrollTag(vm.tag);
            vm.getPayrolls();
            vm.close();
          } else {
            alertify.success(response.message);
          }
        });
      }
    }

    function getInvoicesBankAccount() {
      InvoicesService.getInvoicesBankAccount().then(function(response) {
        vm.bankCreditAccountList = response.data;
        if (typeof payrollId !== 'undefined' && vm.payrollId !== null) {
          vm.fillForm(payrollId);
        }
      }).catch(function(err) {
      });
    }

    function close() {
      $uibModalInstance.close();
    }

    function fillForm(payrollId) {
      let query = {};
      query['id'] = payrollId;
      PayrollService.edit(query).then(function (response) {
        vm.form = response.data;
        vm.sellerSelected = vm.form.seller_id;
        vm.bankCreditAccountSelected = vm.form.bank_id;
        vm.selectedCurrency = vm.form.currency;
        vm.tag = vm.form.tag;
        vm.totalToBePaid = vm.form.amount;
        vm.calculatedCurrency = vm.form.currency;
        vm.history = vm.form.history;
        vm.paymentDate = vm.form.date;
        vm.actions_disabled = !!(vm.form.status == 'paid');
        vm.items = vm.form.items;
        $timeout(function () {
          vm.checkTotal();
        }, 1);
      }).catch(function (err) {});
    }
  }
})();
